class CartNotification extends HTMLElement {
  constructor() {
    super();
    // Cart type is set to Drawer. This component is intentionally inert.
    // All add-to-cart handling is done by CartDrawer.
  }

  open() {}
  close() {}

  renderContents(parsedState) {
    // Intentionally no-op. CartDrawer handles all add-to-cart rendering.
    // Only update the cart icon bubble.
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble && parsedState.sections && parsedState.sections['cart-icon-bubble']) {
      cartIconBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections['cart-icon-bubble']);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);